import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	NATIVE_CALCULATOR_SCREENS,
	SHELL_GATED_CALCULATOR_SCREENS,
} from "web_myplann/Calculators/Utils/nativeCalculatorScreens";
import { isNavigationSupported } from "web_myplann/Shared/Utils/isNavigationSupported";
import { NavigationTypes } from "web_myplann/Utils/device";
import type { NavigationType } from "web_myplann/Utils/WebViewModel";

export const getNativeCalculatorScreen = (
	type: CalculatorType,
	supportedNavigationTypes: readonly NavigationType[] | undefined,
) => {
	const screen = NATIVE_CALCULATOR_SCREENS[type];

	if (
		!screen ||
		(SHELL_GATED_CALCULATOR_SCREENS.includes(screen) &&
			!isNavigationSupported(supportedNavigationTypes, screen))
	) {
		return NavigationTypes.CalculatorListScreen;
	}

	return screen;
};
